var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useCallback, useEffect, useMemo, useRef, useState, } from "react";
import { useSelector, useDispatch } from "react-redux";
import DatePicker from "react-datepicker";
import moment from "moment";
// stylesheet
import "./PaymentMode.scss";
// components
import InputComponent from "../InputComponent";
import RadioType from "../RadioComponent/RadioComponent";
// helpers
import { paymentOptions } from "../../constants/constant";
import aifPmsDi from "@mainDi/features/AIF-PMS/servicelocator";
// types
import { EHoldingType } from "@domains/features/Markets/AIF-PMS/entities/PurchaseEntity";
import { alphaNumExp } from "@frameworks/salesjourney/utils/regex";
import BankSelector from "../BankSelector";
var PaymentMode = function (_a) {
    //
    var _b, _c, _d;
    var calendarRef = useRef(null);
    var dispatch = useDispatch();
    var paymentProcess = useSelector(function (state) { return state.markets.payment; });
    var clientDetails = useSelector(function (state) { return state.markets.AifPms; }).clientDetails;
    var _e = __read(useState(false), 2), isRequired = _e[0], setIsRequired = _e[1];
    var _f = __read(useState(false), 2), isValid = _f[0], setIsValid = _f[1];
    var paymentMode = useSelector(function (state) { return state.markets.payment; }).paymentMode;
    var validateField = function (name, value) {
        var isFieldValid = true;
        if (name === "rtgsNo" && value.length < 3) {
            isFieldValid = false;
        }
        if (name === "chequeNo" && !/^[a-zA-Z0-9 ]*$/.test(value)) {
            isFieldValid = false;
        }
        return isFieldValid;
    };
    var handleOnChangeInputs = useCallback(function (name, value) {
        var _a;
        var updatedPaymentProcess = __assign(__assign({}, paymentProcess.paymentMode), (_a = {}, _a[name] = value, _a));
        var isFieldValid = validateField(name, value);
        if (name === "rtgsNo") {
            setIsRequired(!isFieldValid);
        }
        else if (name === "chequeNo") {
            setIsValid(!isFieldValid);
        }
        aifPmsDi.payment.updatePaymentModeValues(updatedPaymentProcess);
    }, [paymentProcess, dispatch]);
    useEffect(function () {
        var _a, _b;
        aifPmsDi.aifPms.commonBankMaster({
            searchKey: (_b = (_a = paymentMode.bankName) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : "",
            page: 1,
            pageSize: 10,
            orderBy: "bankName",
            orderByDesc: false,
        });
    }, [clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.ucccode, paymentMode.type]);
    var handleOnChangeRtgs = function (event) {
        var value = event.target.value;
        if (alphaNumExp.test(value)) {
            aifPmsDi.payment.updatePaymentModeValues(__assign(__assign({}, paymentMode), { rtgsNo: value }));
        }
    };
    var handleOnChangeTab = function (e) {
        aifPmsDi.payment.updatePaymentModeValues({
            type: e,
            chequeDate: "",
            chequeNo: "",
            bankName: {
                label: "",
                value: "",
            },
            rtgsNo: "",
        });
    };
    var handleOnChangeDate = function (date) {
        aifPmsDi.payment.updatePaymentModeValues(__assign(__assign({}, paymentMode), { chequeDate: moment(date).format("YYYY/MM/DD") }));
    };
    var handleKeyPress = function (event) {
        var charCode = event.charCode || event.keyCode;
        var key = String.fromCharCode(charCode);
        if (/^[a-zA-Z0-9]$/.test(key)) {
            return true;
        }
        event.preventDefault();
    };
    var isRtgsError = useMemo(function () {
        var _a;
        return (paymentMode.type === EHoldingType.RTGS &&
            ((_a = paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.bankName) === null || _a === void 0 ? void 0 : _a.label) !== "" &&
            !(paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.rtgsNo));
    }, [
        paymentMode.type,
        (_b = paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.bankName) === null || _b === void 0 ? void 0 : _b.label,
        paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.rtgsNo,
        EHoldingType,
    ]);
    var isChequeNoError = useMemo(function () {
        var _a;
        return (paymentMode.type === EHoldingType.Cheque &&
            ((_a = paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.bankName) === null || _a === void 0 ? void 0 : _a.label) !== "" &&
            !(paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.chequeNo));
    }, [
        paymentMode.type,
        (_c = paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.bankName) === null || _c === void 0 ? void 0 : _c.label,
        paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.chequeNo,
        EHoldingType,
    ]);
    var isChequeDateError = useMemo(function () {
        var _a;
        return (paymentMode.type === EHoldingType.Cheque &&
            ((_a = paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.bankName) === null || _a === void 0 ? void 0 : _a.label) !== "" &&
            (paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.chequeNo) !== "" &&
            !(paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.chequeDate));
    }, [
        paymentMode.type,
        (_d = paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.bankName) === null || _d === void 0 ? void 0 : _d.label,
        paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.chequeNo,
        paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.chequeDate,
        EHoldingType,
    ]);
    return (React.createElement("div", { className: "aifpms-journey" },
        React.createElement("label", { className: "ai-label DMSanN_14_400 mb-2" },
            "Payment mode ",
            React.createElement("span", { className: "redstar" }, "*")),
        React.createElement("div", { className: "aif-pms-radio" },
            React.createElement(RadioType, { recommendedType: EHoldingType.RTGS, availableList: paymentOptions, selected: paymentProcess.paymentMode.type, setPhysicalFlg: handleOnChangeTab })),
        paymentProcess.paymentMode.type === EHoldingType.RTGS && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "d-flex align-items-start gap-2 new-mandate-section mt-4 mb-4" },
                React.createElement("div", { className: "w-100 dropdown-container" },
                    React.createElement(BankSelector, null))),
            React.createElement(InputComponent, { label: "RTGS No", placeholder: "Enter RTGS No", helperText: "", name: "rtgsNo", required: true, isInvalid: isRequired || isRtgsError, onChangeEvent: function (event) {
                    handleOnChangeRtgs(event);
                }, onKeyPress: handleKeyPress, value: paymentProcess.paymentMode.rtgsNo, maxLength: 30 }))),
        paymentProcess.paymentMode.type === EHoldingType.Cheque && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "d-flex align-items-start gap-2 new-mandate-section mt-4 mb-4" },
                React.createElement("div", { className: "w-100 dropdown-container" },
                    React.createElement(BankSelector, null))),
            React.createElement(InputComponent, { label: "Cheque No", placeholder: "Enter Cheque No", helperText: "", name: "chequeNo", isInvalid: isValid || isChequeNoError, errorText: isValid ? "Cheque number cannot contain special characters." : "", passErrorTextButHideErrTxt: true, onChangeEvent: function (event) {
                    var _a;
                    var value = (_a = event.target.value) === null || _a === void 0 ? void 0 : _a.trim();
                    handleOnChangeInputs("chequeNo", value);
                }, value: paymentProcess.paymentMode.chequeNo, maxLength: 6, integer: true }),
            React.createElement("div", { className: "mt-3" },
                React.createElement("label", { className: "label DMSanN_14_400" },
                    "Cheque Date ",
                    React.createElement("span", { className: "redstar" }, "*")),
                React.createElement("div", { className: "calendar-container" },
                    React.createElement(DatePicker, { ref: calendarRef, name: "chequeDate", className: "".concat(isChequeDateError && "border-red", " calendar"), placeholderText: "Enter Cheque Date", dateFormat: "d-MMM-yyyy", selected: paymentProcess.paymentMode.chequeDate
                            ? new Date(paymentProcess.paymentMode.chequeDate)
                            : undefined, onSelect: handleOnChangeDate, onChange: function (date) { return handleOnChangeInputs("chequeDate", date); } }),
                    React.createElement("p", { className: "calendar-icon" },
                        React.createElement("i", { className: "edel-icon-calendar-rounded", onClick: function () {
                                calendarRef.current.setOpen(true);
                            } }))))))));
};
export default PaymentMode;
